import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgFabricsamples32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path d="M24 5a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2h-4l-.021-.001L7 27a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h.601l-.967-.559a2 2 0 0 1-.805-2.593l.073-.139 2-3.464a2 2 0 0 1 2.594-.805l.138.073.348.201-.335-.58a2 2 0 0 1 .6-2.649l.132-.083 3.464-2a2 2 0 0 1 2.649.6l.083.132.425.736V7a2 2 0 0 1 2-2zM9.334 20H7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h11.268a1.99 1.99 0 0 1-.268-.997zM24 6h-4a1 1 0 0 0-1 1v18a1 1 0 0 0 .984 1l.871-.001.001.001H24a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1m-3 17a1 1 0 1 1 0 2 1 1 0 0 1 0-2M8.832 12.648l-.064.097-2 3.464a1 1 0 0 0 .268 1.302l.098.064 10.848 6.263-6-10.393-1.848-1.066a1 1 0 0 0-1.302.269m6.616-5.433-.105.053-3.464 2a1 1 0 0 0-.418 1.262l.052.104L18 21.87v-12l-1.29-2.236a1 1 0 0 0-1.262-.419" className="fabricsamples-32_svg__path-1" /></SvgIcon>;
};
const Memo = memo(SvgFabricsamples32);
export default Memo;